import React from 'react';
import {
  Input,
  Button,
  FormControl,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useColorModeValue,
} from '@chakra-ui/core';
import { useForm } from 'react-hook-form';

interface NicknameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitName: (nickname: string) => void;
}

const NicknameModal = ({
  isOpen,
  onClose,
  onSubmitName,
}: NicknameModalProps) => {
  const { handleSubmit, register, errors } = useForm();
  const modalBg = useColorModeValue('white', 'gray.800');

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg={modalBg} borderRadius="xl">
        <form
          onSubmit={handleSubmit(data => {
            onSubmitName(data.participantName);
            onClose();
          })}
          autoComplete="off">
          <ModalHeader>Enter a nickname</ModalHeader>
          <ModalBody>
            <FormControl isInvalid={!!errors.participantName}>
              <Input
                name="participantName"
                data-lpignore="true"
                placeholder="Participant Name"
                focusBorderColor="purple.400"
                ref={register({
                  required: 'Required',
                })}
                isInvalid={!!errors.participantName}
              />
              <FormErrorMessage>
                {errors.participantName?.message}
              </FormErrorMessage>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" colorScheme="purple" mr={3}>
              Continue
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default NicknameModal;
